import apiClient from "../core/HttpClient";
import { CharityIssueCharity } from "../models";

export default class CharityIssueCharityService {
    url="/CharityIssueCharities";
    async getCharityIssueCharities(){
        return apiClient.get(this.url).then((response) => {
            return response.data;
        });
    }
    async getCharityIssueCharity(id: number){
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });
    }
    async getCharityIssueByCharity(charityId: number){
        return apiClient.get(`${this.url}/charity/${charityId}`).then((response) => {
            return response.data;
        });
    }
    async createCharityIssueCharity(charityIssueCharity: CharityIssueCharity){
        return apiClient.post(this.url, charityIssueCharity);
    }
    async updateCharityIssueCharity(id: number, charityIssueCharity: CharityIssueCharity){
        return apiClient.put(`${this.url}/${id}`, charityIssueCharity);
    }
    async deleteCharityIssueCharity(id: number){
        return apiClient.delete(`${this.url}/${id}`);
    }
}